import { Box } from "@nulogy/components";
import ModalFormButtons from "components/controls/ModalFormButtons";
import BlockModal from "components/pages/schedule/styles/BlockModal";
import WorkBlock from "domain/WorkBlock";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import useRescheduleBlocks from "hooks/apollo/blocks/useRescheduleBlocks";
import useUpdateWorkOrder from "hooks/apollo/workOrder/useUpdateWorkOrder";
import useEditWorkBlockState from "hooks/state/useWorkBlockEditModal";
import useWorkBlockModal from "hooks/state/useWorkBlockModal";
import React, { useState } from "react";
import Num from "utils/Num";
import EditWorkBlockModalView from "./EditWorkBlockModalView";

export default function EditWorkBlockModalContainer() {
  const applicationContext = useApplicationContext();
  const {
    customerSettings: { workBlockLayout },
  } = applicationContext;
  const { block: blockData, isOpen, close } = useEditWorkBlockState();
  const workBlockModalUIState = useWorkBlockModal();
  const rescheduleBlocks = useRescheduleBlocks();
  const updateWorkOrder = useUpdateWorkOrder();

  const [workBlockErrors, setWorkBlockErrors] = useState({});

  if (!blockData) return null;

  const { block } = blockData;

  const selectedWorkOrder = block.workOrder;
  const selectedLine = block.line;

  const effectiveProductionRateFor = (workBlock) =>
    WorkBlock.effectiveProductionRate({
      ...block,
      ...workBlock,
      efficiencyOverride: Num.percentToDecimal(workBlock.efficiencyOverride),
      line: selectedLine,
      performanceOverride: Num.percentToDecimal(workBlock.performanceOverride),
    });

  const expectedQuantityFor = (workBlock) =>
    WorkBlock.quantity({
      ...block,
      ...workBlock,
      efficiencyOverride: Num.percentToDecimal(workBlock.efficiencyOverride),
      line: selectedLine,
      performanceOverride: Num.percentToDecimal(workBlock.performanceOverride),
    });

  async function handleSave(workBlock) {
    const updatedWorkBlock = WorkBlock.buildWithWorkTime(workBlock);
    await rescheduleBlocks([updatedWorkBlock]);
    updateWorkOrder({ id: workBlock.workOrder.id, notes: workBlock.workOrder.notes });
  }

  const disabled = Object.keys(workBlockErrors).length > 0;

  const handleClose = () => {
    setWorkBlockErrors({});
    close();
  };

  return (
    <BlockModal
      className="spec-block-modal"
      footerContent={
        <ModalFormButtons
          disabled={disabled}
          formId="editWorkBlock"
          onClose={handleClose}
          pendoTagClass="pendo-edit-work-block-modal-save"
        />
      }
      isOpen={isOpen}
      onRequestClose={handleClose}
      title="Edit work block"
    >
      <Box position="relative">
        <EditWorkBlockModalView
          blockData={blockData}
          effectiveProductionRateFor={effectiveProductionRateFor}
          expectedQuantityFor={expectedQuantityFor}
          onClose={handleClose}
          onSave={handleSave}
          selectedLine={selectedLine}
          selectedWorkOrder={selectedWorkOrder}
          setErrors={setWorkBlockErrors}
          workBlockLayout={workBlockLayout}
          workBlockModalUIState={workBlockModalUIState}
        />
      </Box>
    </BlockModal>
  );
}
